import { IRecieptProps } from "./Reciept";

export const View = (props: IRecieptProps) => {
  return (
    <div className="flex-container reciept-container-brand col gap-2 justify-content--center align-items--center">
      <div className="flex-container brand-blank-link gap-1 align-items--center justify-content--center">
        <svg
          className="w-6 h-6"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path>
          <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path>
        </svg>{" "}
        Send a text reciept
      </div>

      <div className="main-brand-preview-container">
        <div className="main-top">
          <div className="top">
            {props.topLeft}
            {props.topRight}
          </div>
          <div className="bottom">
            {props.mainTitle}
            {props.subTitle}
            {props.extraPhrase}
          </div>
        </div>
        <div className="middle-text">{props.middletext}</div>
        <div className="main-content">{props.mainPage}</div>
        <div style={{ height: "50px" }} className="center">
          &copy; SwitchApp Technologies 2022
        </div>
      </div>
    </div>
  );
};
